import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@tcc-mono/shared/app-config';
import { BaseService } from '@tcc-mono/shared/data-access';
import { Transport } from '@tcc-mono/vandijk/shared/data-access/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TransportService extends BaseService<Transport> {
  public constructor(
    _http: HttpClient,
    @Inject(APP_CONFIG) appConfig: IAppConfig
  ) {
    super(_http, appConfig);
    this.path = 'api/transports';
  }

  public exportPDF(id: number, showWeights?: boolean): Observable<any> {
    const params = showWeights !== undefined ? { show_weight: showWeights } : {};
    return this._http.get(this.getUrl(`${this.path}/${id}/download_pdf`), {
      responseType: 'blob',
      params
    });
  }
}
